import Auth from "@creditsafe/upp-authentication";

import { broadcastLogout } from "./broadcastLogout";

export const LOGOUT_REDIRECT_URL = "https://www.creditsafe.com/us/en.html";

let isLoggingOut = false;

const clearOidcStorage = (): void => {
  [localStorage, sessionStorage].forEach((storage) => {
    Object.keys(storage)
      .filter((key) => key.startsWith("oidc."))
      .forEach((key) => storage.removeItem(key));
  });
};

export const clearLocalAuthState = (): void => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("resetTimersRun");
  localStorage.removeItem("activity");
  clearOidcStorage();
};

export const performLogout = (): void => {
  if (isLoggingOut) {
    return;
  }

  isLoggingOut = true;

  try {
    Auth.signOut();
  } catch {
    clearLocalAuthState();
    window.location.replace(LOGOUT_REDIRECT_URL);
  }
};

export const syncLogoutFromOtherTab = (): void => {
  if (isLoggingOut) {
    return;
  }

  isLoggingOut = true;
  clearLocalAuthState();
  window.location.replace(LOGOUT_REDIRECT_URL);
};

export const logout = (): void => {
  broadcastLogout();
  performLogout();
};
